<script>
  import { crosswalk } from './../stores.js';
  import { __,__c } from './../utils/i18n.js';

  /** @type {string} */
    export let lookup;
      /** @type {string} */
    export let className;
      /** @type {string} */
    export let idName;
      /** @type {string} */
    export let ariaHidden;
      /** @type {string} */
    export let lazyLoad;
    /** @type {string} */
      

    // console.log("TESKJDLKFJLKSJDLKFJLKSJLKFSJKLSDSKDJFLKJSLKEJLKJL");
    // console.log("IN PHOTOS", lookup);

    let imageName = crosswalk.get(lookup).img;
    let avif = crosswalk.get(lookup).avif;
    let webp = crosswalk.get(lookup).webp;
    // let alt = crosswalk.get(lookup).alt;
    let alt = crosswalk.get(lookup)[__c("alt")];
</script>
  
<div class="img-wrapper {className}">
  <picture id="{idName}" aria-hidden="{ariaHidden}">
    {#if avif }
    <source
      type="image/avif"
      srcset={avif}
    />
    {/if}
    {#if webp }
    <source
      type="image/webp"
      srcset={webp}
    />
    {/if}
    <img 
      loading="{lazyLoad == 'true' ? 'lazy' : ''}"
      src="{imageName}"
      alt="{alt}"
      width="30" 
      height="30"
    />
  </picture>
</div>  